"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _SocialProfilesContent = _interopRequireDefault(require("./SocialProfilesContent")),
    _Form = _interopRequireDefault(require("../../Form"));

function SocialProfiles(_ref) {
  var socialProfiles = _ref.socialProfiles,
      profileImage = _ref.profileImage,
      onSave = _ref.onSave,
      title = _ref.title,
      className = _ref.className,
      defaultImage = _ref.defaultImage,
      imagePlaceholder = _ref.imagePlaceholder,
      allowedSocialTypes = _ref.allowedSocialTypes,
      modalTitle = _ref.modalTitle,
      modalDescription = _ref.modalDescription,
      buttonTitle = _ref.buttonTitle,
      onSelectImage = _ref.onSelectImage,
      disabled = _ref.disabled;
  return _react["default"].createElement(_Form["default"].TitledFormBlock, {
    title: title,
    className: className,
    itemImage: profileImage,
    defaultImage: defaultImage,
    imagePlaceholder: imagePlaceholder
  }, _react["default"].createElement(_SocialProfilesContent["default"], {
    socialProfiles: socialProfiles,
    onSave: onSave,
    modalTitle: modalTitle,
    modalDescription: modalDescription,
    buttonTitle: buttonTitle,
    allowedSocialTypes: allowedSocialTypes,
    onSelectImage: onSelectImage,
    disabled: disabled
  }));
}

var _default = (0, _react.memo)(SocialProfiles);

exports["default"] = _default;